import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';
import checklistForm from '../checklistForm';
import totalNumberForm from './totalNumberForm';
import coreDataForm from './coreDataForm';
import policeMeasureForm from './policeMeasureForm';
import anamnesisForm from './anamnesisForm';
import contactForm from './contactForm';
import casePresentationDataForm from '../commonForms/casePresentation';
import onwardPlacementForm from './onwardPlacementForm';

const interventionCenterFirstForms: Form<Client>[] = [checklistForm, totalNumberForm, coreDataForm, policeMeasureForm];
const interventionCenterSecondForms: Form<Client>[] = [anamnesisForm, contactForm, casePresentationDataForm];
const interventionCenterThirdForms: Form<Client>[] = [onwardPlacementForm];

export { interventionCenterFirstForms, interventionCenterSecondForms, interventionCenterThirdForms };
